import { useEffect, useState } from "react";
import { CalendarRange, Loader2, Printer } from "lucide-react";
import { toast } from "sonner";
import { api, errMsg, saveBlob, fetchBlob } from "@/lib/api";
import { todayISO } from "@/lib/util";

const prevMonth = () => {
  const [y, m] = todayISO().split("-").map(Number);
  return m === 1 ? `${y - 1}-12` : `${y}-${String(m - 1).padStart(2, "0")}`;
};

const MONTHS = ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"];

export default function MonthArchive({ labels }) {
  const [ym, setYm] = useState(prevMonth());
  const [s, setS] = useState(null);
  const [busy, setBusy] = useState(false);
  const cy = Number(todayISO().slice(0, 4));
  const years = Array.from({ length: 6 }, (_, i) => String(cy - i));
  useEffect(() => {
    if (!ym) { return; }
    setS(null);
    api.get(`/archive/month/${ym}`).then((r) => setS(r.data)).catch((e) => toast.error(errMsg(e)));
  }, [ym]);
  const print = async () => {
    setBusy(true);
    try { saveBlob(await fetchBlob(`/archive/month/${ym}/pdf`), `archive-${ym}.pdf`); toast.success("تم تجهيز ملف الشهر"); } catch (e) { toast.error(errMsg(e)); }
    setBusy(false);
  };
  return (
    <div className="mt-4 pt-4 border-t border-slate-100 flex flex-wrap items-center gap-3" data-testid="month-archive">
      <CalendarRange className="w-5 h-5 text-brand" />
      <b className="text-sm">طباعة شهر محدد:</b>
      <select data-testid="month-archive-month" className="field field-sm w-32" value={ym.slice(5)} onChange={(e) => setYm(`${ym.slice(0, 4)}-${e.target.value}`)}>
        {MONTHS.map((n, i) => <option key={n} value={String(i + 1).padStart(2, "0")}>{n}</option>)}</select>
      <select data-testid="month-archive-year" className="field field-sm w-28" value={ym.slice(0, 4)} onChange={(e) => setYm(`${e.target.value}-${ym.slice(5)}`)}>
        {years.map((y) => <option key={y} value={y}>{y}</option>)}</select>
      <span className="text-sm text-slate-500 flex-1 min-w-[180px]" data-testid="month-archive-counts">
        {s ? <>المجموع <b className="text-brand">{s.total}</b>: {labels.map(([k, l]) => `${s.counts[k]} ${l}`).join("، ")}</> : "..."}
      </span>
      <button data-testid="month-archive-print-btn" onClick={print} disabled={busy || !s?.total} className="btn btn-lg btn-blue">
        {busy ? <Loader2 className="w-5 h-5 animate-spin" /> : <Printer className="w-5 h-5" />}{busy ? "جارِ التجهيز..." : "طباعة الشهر PDF"}</button>
    </div>
  );
}
